import React from "react";
import { Spinner } from "./icons";

function Loader({ isLoading = false }) {
  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "grid",
            placeItems: "center",
          }}
        >
          <Spinner />
        </div>
      ) : null}
    </>
  );
}

export default Loader;
